import { NEAR_WHITE } from "../../../config/colors";
import styled from "styled-components";

export const StatusContainer = styled.div<{
  disable?: boolean;
  color: string;
}>`
  align-items: center;
  justify-content: center;
  display: inline-flex;

  color: ${({ disable }) => (disable ? `${NEAR_WHITE}33` : NEAR_WHITE)};
  background: ${({ disable, color }) => (disable ? `${color}33` : color)};
  border-radius: 5px;

  padding: 7px;
  margin-right: 5px;

  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 15px;
  text-align: center;
  text-transform: capitalize;
`;
